<script>
import options from "./FindCenterMapAndEmployees.options"
export default options
</script>

<template>
    <article class="nyk-find-center-map-and-employees">
        <div class="nyk-find-center-map-and-employees__filters">
            <FilterTabs :can-show-dropdown="true" dropdown-label="Vælg mellem medarbejder og center" init-active-tab="GoogleMaps" :tabs="tabs" :callback="findCenterFilterChanged" />
        </div>

        <div class="nyk-find-center-map-and-employees__sections">
            <div
                aria-labelledby="GoogleMaps"
                :class="{
                    'nyk-find-center-map-and-employees__sections__content--hidden': !showCenterMaps,
                }">
                <template v-if="centerInformation.length > 0">
                    <CenterMap
                        :categories="categories"
                        :bankTypes="bankTypes"
                        :labels="labels"
                        :mapkey="mapkey"
                        :apiUrl="centersApiUrl"
                        :centerInformation="centerInformation"
                        :designSchema="designSchema"
                        :searchRadius="searchRadius" />
                </template>
            </div>

            <div
                aria-labelledby="Employees"
                :class="{
                    'nyk-find-center-map-and-employees__sections__content--hidden': showCenterMaps,
                }">
                <template v-if="centerInformation.length > 0">
                    <FindCenterContactPersons
                        :defaultImage="defaultEmployeesImage"
                        :apiUrl="contactPersonsApiUrl"
                        :centerInformation="staffedCenters"
                        :contactUrl="contactUrl"
                        :labels="centerLabels"/>
                </template>
            </div>
        </div>
    </article>
</template>
